import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { Societe } from "../../types/entities";

export const useGetSocietes = () =>
  useQuery({
    queryKey: ["societes"],
    queryFn: async (): Promise<Societe[]> => {
      const resp = await fetchClient<Societe[]>("/iam/societe/");
      if (resp.error || !resp.data) throw resp.error || new Error("Failed to fetch Societes");
      return resp.data;
    },
    staleTime: 5 * 60 * 1000,
  });

export default useGetSocietes;
